module.exports = __webpack_public_path__ + "fonts/dm-sans-v15-latin-500.woff2";